module.exports = __webpack_public_path__ + "img/powerpoint.d37a4add.svg";